import { getLoginInfo } from "../auth/getLoginInfo";
import { getAuth } from "../auth/publicUsers/authStorage";
import { createAxios, createAxiosWithToken } from "./createAxios";

export async function pushTokenSaveToken(param) {
        try {
                let loginData = getAuth();
                if (loginData)
                        return await createAxiosWithToken(loginData.token).post(`/Push/SaveToken`, param)
        } catch (err) {
                return err
        }

}
export async function pushTokenSaveTokenDoctor(param) {
        try {
                let loginData = getLoginInfo();
                if (loginData)
                        return await createAxiosWithToken(loginData.token).post(`/Push/SaveTokenDoctor`, param)
        } catch (err) {
                return err
        }

}
export async function pushTokenRegisterPublic(param) {
        return await createAxios().post(`/Push/RegisterPublic?Token=${param.token}`)
}